import React from "react";
import type { TFunction } from "i18next";
import { ResourceEnum } from "src/constants/constants.ts";
import type { CustomerResource } from "@exonn/js-sdk";

export const module = {
  id: ResourceEnum.Customer,
  bigIcon: <i className="icon-20-customers" />,
  smallIcon: <i className="icon-15-customers" />,
  name: (t: TFunction) => t("moduleName.customers"),
  tabs: {
    edit: {
      // todo: support providing just a name of property we want to show in tab title
      getTitle: (resource: CustomerResource) => String(resource.number),
    },
  },
};
